import { Liquid, LiquidOptions } from "liquidjs";

export const BLOCK_SERVICE_LIQUID_OPTIONS: LiquidOptions = {
  outputEscape: "escape",
  parseLimit: 100_000,
  renderLimit: 1000,
  templates: {},
};

export function createBlockServiceLiquid(): Liquid {
  const liquid = new Liquid(BLOCK_SERVICE_LIQUID_OPTIONS);
  liquid.registerFilter("raw", (value: unknown) =>
    value == null ? "" : String(value),
  );
  return liquid;
}

export function renderBlockServiceHtml(html: string, context: unknown): string {
  const liquidContext =
    typeof context === "object" && context !== null ? context : {};
  return createBlockServiceLiquid().parseAndRenderSync(html, liquidContext);
}
